module.exports = __webpack_public_path__ + "img/or-menachem-banot.a5ed8574.jpeg";